import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f8e2bd4")

_pushScopeId("data-v-2f8e2bd4")
const _hoisted_1 = { class: "flex flex--width flex--v flex--valign-c" }
const _hoisted_2 = { class: "table table-dark table-striped" }
const _hoisted_3 = { scope: "col" }
const _hoisted_4 = { scope: "col" }
const _hoisted_5 = {
  scope: "col",
  class: "text-center"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("th", {
  scope: "col",
  class: "text-center"
}, null, -1)
const _hoisted_7 = {
  scope: "col",
  class: "text-center"
}
const _hoisted_8 = { scope: "row" }
const _hoisted_9 = { class: "text-center align-middle" }
const _hoisted_10 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_11 = {
  key: 1,
  class: "fas fa-times"
}
const _hoisted_12 = { class: "text-end align-middle" }
const _hoisted_13 = { class: "text-center align-middle" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "far fa-edit fa-lg" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "far fa-copy fa-lg" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt fa-lg" }, null, -1)
const _hoisted_17 = { class: "buttons-flex-list flex flex--width flex--h flex--halign-c flex--valign-c flex--gap-10" }
const _hoisted_18 = { class: "flex flex--v flex--valign-c text text--size-18 text--height-24 text--primary-b text--medium text--center" }
const _hoisted_19 = { class: "flex flex--v flex--valign-c text text--size-18 text--height-24 text--primary-b text--medium text--center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LinkVue = _resolveComponent("LinkVue")
  const _component_inertia_link = _resolveComponent("inertia-link")
  const _component_PaginationNew = _resolveComponent("PaginationNew")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_GenericModal = _resolveComponent("GenericModal")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('navigation.nav_acp_companies')
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("table", _hoisted_2, [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              _createVNode("th", _hoisted_3, _toDisplayString(_ctx.$trans("company.id")), 1),
              _createVNode("th", _hoisted_4, _toDisplayString(_ctx.$trans("company.name")), 1),
              _createVNode("th", _hoisted_5, _toDisplayString(_ctx.$trans("company.active")), 1),
              _hoisted_6,
              _createVNode("th", _hoisted_7, _toDisplayString(_ctx.$trans("acp.options")), 1)
            ])
          ]),
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companies.data, (company) => {
              return (_openBlock(), _createBlock("tr", {
                key: company.id
              }, [
                _createVNode("th", _hoisted_8, _toDisplayString(company.id), 1),
                _createVNode("td", null, _toDisplayString(company.name), 1),
                _createVNode("td", _hoisted_9, [
                  (company.active)
                    ? (_openBlock(), _createBlock("i", _hoisted_10))
                    : (_openBlock(), _createBlock("i", _hoisted_11))
                ]),
                _createVNode("td", _hoisted_12, [
                  (_ctx.policies.COMPANY_CREATE)
                    ? (_openBlock(), _createBlock(_component_LinkVue, {
                        key: 0,
                        href: _ctx.route('companies.create', { copy: company.id }),
                        type: "button",
                        class: "btn btn-info",
                        "preserve-state": false
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$trans("acp.company_create_second")), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("td", _hoisted_13, [
                  (_ctx.policies.COMPANY_CREATE)
                    ? (_openBlock(), _createBlock(_component_inertia_link, {
                        key: 0,
                        href: _ctx.route('companies.edit', { company: company.id }),
                        class: "text-light cursor--pointer"
                      }, {
                        default: _withId(() => [
                          _hoisted_14
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : _createCommentVNode("", true),
                  (_ctx.policies.COMPANY_CREATE)
                    ? (_openBlock(), _createBlock(_component_inertia_link, {
                        key: 1,
                        href: _ctx.route('companies.create', { copy: company.id }),
                        class: "text-light cursor--pointer"
                      }, {
                        default: _withId(() => [
                          _hoisted_15
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : _createCommentVNode("", true),
                  (_ctx.policies.COMPANY_DELETE)
                    ? (_openBlock(), _createBlock("a", {
                        key: 2,
                        class: "text-light cursor--pointer",
                        onClick: ($event: any) => (_ctx.openDeleteCompanyModal(company.id))
                      }, [
                        _hoisted_16
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        (_ctx.companies.data.length > 0)
          ? (_openBlock(), _createBlock(_component_PaginationNew, {
              key: 0,
              "pagination-data": _ctx.companies,
              class: "pagination-new",
              onPaginate: _ctx.loadPage
            }, null, 8, ["pagination-data", "onPaginate"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_GenericButton, {
          title: _ctx.$trans('acp.company_create'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickRoute('companies.create')))
        }, null, 8, ["title"]),
        _createVNode(_component_GenericButton, {
          title: _ctx.$trans('auth.account_delete'),
          danger: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDeleteAccountModal()))
        }, null, 8, ["title"])
      ]),
      (_ctx.deleteCompanyModalOpen)
        ? (_openBlock(), _createBlock(_component_GenericModal, {
            key: 0,
            onClosed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeDeleteCompanyModal()))
          }, {
            title: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$trans("acp.title_modal_delete_company")), 1)
            ]),
            content: _withId(() => [
              _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$trans("acp.body_modal_delete_company")), 1)
            ]),
            buttons: _withId(() => [
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('acp.close'),
                disabled: _ctx.loading,
                circular: true,
                "click-stop": false
              }, null, 8, ["title", "disabled"]),
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('acp.delete'),
                disabled: _ctx.loading,
                circular: true,
                danger: true,
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.deleteAction()), ["stop"]))
              }, null, 8, ["title", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.deleteAccountModalOpen)
        ? (_openBlock(), _createBlock(_component_GenericModal, {
            key: 1,
            onClosed: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeDeleteAccountModal()))
          }, {
            title: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$trans("auth.title_modal_delete_account")), 1)
            ]),
            content: _withId(() => [
              _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$trans("auth.body_modal_delete_account")), 1)
            ]),
            buttons: _withId(() => [
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('acp.close'),
                disabled: _ctx.loading,
                circular: true,
                "click-stop": false
              }, null, 8, ["title", "disabled"]),
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('auth.account_delete'),
                disabled: _ctx.loading,
                circular: true,
                danger: true,
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.deleteAccountAction()), ["stop"]))
              }, null, 8, ["title", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
})